import { render } from "./SobreNos.vue?vue&type=template&id=563a20e6"
import script from "./SobreNos.vue?vue&type=script&lang=js"
export * from "./SobreNos.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__